import { render, staticRenderFns } from "./bestSellersTop10.vue?vue&type=template&id=4bac723a&scoped=true"
import script from "./bestSellersTop10.vue?vue&type=script&lang=js"
export * from "./bestSellersTop10.vue?vue&type=script&lang=js"
import style0 from "./bestSellersTop10.vue?vue&type=style&index=0&id=4bac723a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac723a",
  null
  
)

export default component.exports